export const GET_ROTATION_SLOTS = "GET_ROTATION_SLOTS";
export const GET_ROTATION_SLOTS_COMPLETED = "GET_ROTATION_SLOTS_COMPLETED";
export const GET_ROTATION_SLOTS_FAILED = "GET_ROTATION_SLOTS_FAILED";

export const POST_ROTATION_SLOT = "POST_ROTATION_SLOT";
export const PUT_ROTATION_SLOT = "PUT_ROTATION_SLOT";
export const DELETE_ROTATION_SLOT = "DELETE_ROTATION_SLOT";
export const POST_ROTATION_SLOT_ENTRY = "POST_ROTATION_SLOT_ENTRY";
export const PUT_ROTATION_SLOT_ENTRY = "PUT_ROTATION_SLOT_ENTRY";
export const DELETE_ROTATION_SLOT_ENTRY = "DELETE_ROTATION_SLOT_ENTRY";
export const PUT_ROTATION_SLOT_PACKAGE = "PUT_ROTATION_SLOT_PACKAGE";
export const DELETE_ROTATION_SLOT_PACKAGE = "DELETE_ROTATION_SLOT_PACKAGE";
export const PUT_ROTATION_SLOT_GROUP = "PUT_ROTATION_SLOT_GROUP";
export const DELETE_ROTATION_SLOT_GROUP = "DELETE_ROTATION_SLOT_GROUP";
export const UPDATE_ROTATION_PERIOD = "UPDATE_ROTATION_PERIOD";
export const PREVIEW_SLOT_ENTRY_CASCADE = "PREVIEW_SLOT_ENTRY_CASCADE";
export const APPLY_SLOT_ENTRY_CASCADE = "APPLY_SLOT_ENTRY_CASCADE";

export const getRotationSlots = () => ({
  type: GET_ROTATION_SLOTS,
  meta: {
    async: true,
    blocking: false,
    path: `/api/pro/offer/rotation-slots.json`,
    method: "GET",
    params: {},
  },
});

export const postRotationSlot = (body) => ({
  type: POST_ROTATION_SLOT,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots.json`, method: "POST", body },
});

export const putRotationSlot = (slotId, body) => ({
  type: PUT_ROTATION_SLOT,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}.json`, method: "PUT", body },
});

export const deleteRotationSlot = (slotId) => ({
  type: DELETE_ROTATION_SLOT,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}.json`, method: "DELETE", body: {} },
});

export const postRotationSlotEntry = (slotId, body) => ({
  type: POST_ROTATION_SLOT_ENTRY,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}/entries.json`, method: "POST", body },
});

export const putRotationSlotEntry = (entryId, body) => ({
  type: PUT_ROTATION_SLOT_ENTRY,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/entries/${entryId}.json`, method: "PUT", body },
});

export const deleteRotationSlotEntry = (entryId) => ({
  type: DELETE_ROTATION_SLOT_ENTRY,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/entries/${entryId}.json`, method: "DELETE", body: {} },
});

export const putRotationSlotPackage = (slotId, body) => ({
  type: PUT_ROTATION_SLOT_PACKAGE,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}/packages.json`, method: "PUT", body },
});

export const deleteRotationSlotPackage = (slotId, packageId) => ({
  type: DELETE_ROTATION_SLOT_PACKAGE,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}/packages/${packageId}.json`, method: "DELETE", body: {} },
});

export const putRotationSlotGroup = (slotId, body) => ({
  type: PUT_ROTATION_SLOT_GROUP,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}/groups.json`, method: "PUT", body },
});

export const deleteRotationSlotGroup = (slotId, groupId) => ({
  type: DELETE_ROTATION_SLOT_GROUP,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/${slotId}/groups/${groupId}.json`, method: "DELETE", body: {} },
});

/**
 * Mise à jour globale d'une période (tous slots) :
 * body = { old_from, old_until, new_from, new_until }
 */
export const updateRotationPeriod = (body) => ({
  type: UPDATE_ROTATION_PERIOD,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/periods/update.json`, method: "POST", body },
});

export const previewSlotEntryCascade = (entryId) => ({
  type: PREVIEW_SLOT_ENTRY_CASCADE,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/entries/${entryId}/cascade/preview.json`, method: "POST", body: {} },
});

export const applySlotEntryCascade = (entryId) => ({
  type: APPLY_SLOT_ENTRY_CASCADE,
  meta: { async: true, blocking: true, path: `/api/pro/offer/rotation-slots/entries/${entryId}/cascade.json`, method: "POST", body: {} },
});
